import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function AppRouter() {
  return <BrowserRouter data-id="element-34">
      <Routes data-id="element-35">
        <Route path="/" element={<App data-id="element-37" />} data-id="element-36" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-39" />} data-id="element-38" />
      </Routes>
    </BrowserRouter>;
}